import { useState } from "react";

interface UsePaginationProps {
  defaultPageSize: number;
}

export const usePagination = ({ defaultPageSize }: UsePaginationProps) => {
  const [page, setPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(defaultPageSize);

  const resetPage = () => {
    setPage(0);
  };
  const incrementPage = () => {
    setPage(page + 1);
  };

  const decrementPage = () => {
    setPage(page - 1);
  };

  return { page, pageSize, incrementPage, decrementPage, resetPage, setPageSize };
};

export type Pagination = ReturnType<typeof usePagination>;
